<template>
	<div class="ks-videoeditor-inspector-body">
		<k-text-field label="Title" :value="clip.title" @input="update({title: $event})"></k-text-field>
		<k-text-field label="Start (s)" type="number" :value="round(clip.start)" @input="$emit('set-start', clip, $event)"></k-text-field>
		<div v-if="!is_image" class="ks-videoeditor-inline">
			<k-text-field label="In (s)" type="number" :value="round(clip.in)" @input="$emit('set-in', clip, $event)"></k-text-field>
			<k-text-field label="Out (s)" type="number" :value="round(clip.out)" @input="$emit('set-out', clip, $event)"></k-text-field>
		</div>
		<k-text-field v-else label="Duration (s)" type="number" :value="round(clip.out - clip.in)" @input="$emit('set-duration', clip, $event)"></k-text-field>
		<div v-if="!is_image" class="ks-videoeditor-meta">Length: <b>{{ fmt(clip.out - clip.in) }}</b> / source {{ fmt(clip.source_duration) }}</div>

		<template v-if="!is_image">
			<div class="ks-videoeditor-inspector-title">Volume</div>
			<slider-field :value="clip.volume" :disabled="clip.muted" @input="update({volume: $event})">
				<k-btn size="s" icon :icon-name="clip.muted ? 'volume_off' : 'volume_up'" :title="clip.muted ? 'Unmute' : 'Mute'" @click="update({muted: !clip.muted})"></k-btn>
			</slider-field>
		</template>

		<template v-if="clip.qualities && clip.qualities.length">
			<k-autocomplete
				label="Quality"
				:items="quality_items"
				:value="clip.source && clip.source.clip_uuid"
				item-text="label"
				item-value="uuid"
				@input="$emit('set-quality', clip, $event)">
			</k-autocomplete>
		</template>

		<frame-position :item="clip" @preset="$emit('preset', clip, $event)" @change="update"></frame-position>

		<div class="ks-videoeditor-inspector-title">Opacity</div>
		<slider-field :value="clip.opacity" @input="update({opacity: $event})"></slider-field>

		<transition-field title="Transition in" :value="clip.transition" @input="update({transition: $event})">
			<div class="ks-videoeditor-meta">A fade blends the clip in over whatever is behind it. Shift-click a second clip to set a transition between two clips.</div>
		</transition-field>

		<transition-field title="Transition out" :value="out_transition(clip)" @input="update({transition_out: $event})">
			<div class="ks-videoeditor-meta" v-if="crossfades_out">The next clip cross-fades over this one, so the out transition is not used.</div>
			<div class="ks-videoeditor-meta" v-else>A fade out blends the clip away to whatever is behind it at its end.</div>
		</transition-field>

		<div class="ks-videoeditor-inline ks-videoeditor-actions">
			<k-btn size="s" icon icon-name="my_location" title="Start at playhead" @click="$emit('start-at-playhead', clip)"></k-btn>
			<k-btn size="s" icon icon-name="content_cut" @click="$emit('split')">Split</k-btn>
			<k-btn size="s" icon icon-name="content_copy" @click="$emit('duplicate-clip', clip)"></k-btn>
			<k-btn size="s" color="error" icon icon-name="delete" @click="$emit('remove-clip', clip)"></k-btn>
		</div>
	</div>
</template>

<script>
import FramePosition from './FramePosition.vue'
import SliderField from './SliderField.vue'
import TransitionField from './TransitionField.vue'
import {fmt, out_transition, round} from './utils.js'

// Properties of a video or image clip. Changes are emitted as update(item, patch); edits that depend on the other clips are emitted as set-* events.
export default {
	components: {FramePosition, SliderField, TransitionField},
	props: {
		clip: Object,
		crossfades_out: Boolean
	},
	computed: {
		is_image () {
			return this.clip.type == "image";
		},
		quality_items () {
			return _.map(this.clip.qualities, (q) => ({
				uuid: q.uuid,
				label: (q.title || q.name || q.uuid) + (q.subtitle ? " (" + q.subtitle + ")" : "")
			}));
		}
	},
	methods: {
		fmt,
		round,
		out_transition,
		update (patch) {
			this.$emit("update", this.clip, patch);
		}
	}
}
</script>
